import type { PartnerStatus, PartnerUserLinkRole, RevenuePartnerUserLink } from "../../types/revenueOps";

export const PARTNER_USER_LINK_ROLES: Array<{ value: PartnerUserLinkRole; label: string }> = [
  { value: "owner", label: "Owner" },
  { value: "member", label: "Member" },
  { value: "finance", label: "Finance" },
  { value: "viewer", label: "Viewer" },
];

export function isPartnerUserLinkRole(value: unknown): value is PartnerUserLinkRole {
  return PARTNER_USER_LINK_ROLES.some((role) => role.value === value) || ["partner_admin", "partner_member", "partner_finance", "partner_read_only"].includes(String(value));
}

export function normalizePartnerUserLinkInput(input: { partner_id?: string | null; user_id?: string | null; role?: string | null; is_active?: boolean; notes?: string | null }) {
  return {
    partner_id: String(input.partner_id || "").trim(),
    user_id: String(input.user_id || "").trim(),
    role: String(input.role || "").trim(),
    is_active: input.is_active !== false,
    notes: String(input.notes || "").trim() || undefined,
  };
}

export function validatePartnerUserLinkInput(input: { partner_id?: string | null; user_id?: string | null; role?: string | null }, partnerStatus?: PartnerStatus, allowInactivePartner = false): string | null {
  const normalized = normalizePartnerUserLinkInput(input);
  if (!normalized.partner_id) return "Select a partner.";
  if (!normalized.user_id) return "Enter an existing auth/account user ID.";
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(normalized.user_id)) return "Enter a valid existing user UUID.";
  if (!isPartnerUserLinkRole(normalized.role)) return "Select a valid partner access role.";
  if (partnerStatus && partnerStatus !== "active" && !allowInactivePartner) return "The selected partner is inactive. Confirm before linking a user.";
  return null;
}

export function findDuplicateActivePartnerUserLink(links: RevenuePartnerUserLink[], partnerId: string, userId: string, excludeId?: string): RevenuePartnerUserLink | undefined {
  return links.find((link) => link.id !== excludeId && link.partner_id === partnerId && link.user_id === userId && link.is_active);
}

export function getActivePartnerLinksForUser(links: RevenuePartnerUserLink[], userId: string): RevenuePartnerUserLink[] {
  return links.filter((link) => link.user_id === userId && link.is_active);
}

export function getPartnerUserLinkRoleLabel(role: PartnerUserLinkRole): string {
  return PARTNER_USER_LINK_ROLES.find((item) => item.value === role)?.label || role;
}
